/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NewContentDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    contentLanguage: NewContentDto.contentLanguage;
    title?: string;
    content?: string;
};
export namespace NewContentDto {
    export enum contentLanguage {
        DE = 'DE',
        EN = 'EN',
    }
}

